import { render, staticRenderFns } from "./Borrower.vue?vue&type=template&id=23526d22"
import script from "./Borrower.vue?vue&type=script&lang=js"
export * from "./Borrower.vue?vue&type=script&lang=js"
import style0 from "./Borrower.vue?vue&type=style&index=0&id=23526d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports